import gql from 'graphql-tag';

const query = gql`
  query MeAccessTo {
    me {
      id
      diet {
        id
        accessTo
      }
    }
  }
`;

export default query;
